import React, { useState } from 'react';

import { convertToSeconds } from './TimeUtils';

const SwimTime = ({ callback }) => {
    const [pace, setPace] = useState('2:00');

    const updatePace = value => {
        setPace(value);

        const secondsPer100 = convertToSeconds(value);

        if (secondsPer100 > 0) {
            callback('swim', (secondsPer100 * 10));
        }
    }

    return (
        <div>
            <h2>Swim time</h2>
            <label>
                <p>Enter your pace per 100 metres in m:ss format</p>
                <input
                    type="text"
                    value={pace}
                    onChange={event => updatePace(event.target.value)}
                />
            </label>
        </div>
    );
};

export default SwimTime;
